import request from "@/utils/request";

export async function queryHelpCenterByIdGuideList(playload) {
  return request({
    url: "/api/v2/cms/queryHelpCenterByIdGuideList",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 咨询文章列表
 *
 * @description 咨询文章列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAdvisoryEssayList(playload, config) {
  return request({
    url: "/api/v2/cms/queryAdvisoryEssayList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 咨询文章详情
 *
 * @description 咨询文章详情
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAdvisoryEssayById(playload) {
  return request({
    url: "/api/v2/cms/queryAdvisoryEssayById",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
export async function queryHelpCenterByNameGuideList(playload, config) {
  return request({
    url: "/api/v2/cms/queryHelpCenterByNameGuideList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 二维码与客服信息
 *
 * @description 二维码与客服信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryQrcodesAndServicer(playload) {
  return request({
    url: "/api/v2/cms/queryQrcodesAndServicer",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 优惠活动列表
 *
 * @description 优惠活动列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryDiscountActivityList(playload) {
  return request({
    url: "/api/v2/cms/queryDiscountActivityList",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 优惠活动详情
 *
 * @description 优惠活动详情
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryDiscountActivityById(playload) {
  return request({
    url: "/api/v2/cms/queryDiscountActivityById",
    method: "POST",
    data: playload,
    loading: true,
    noEncrypt: true
  });
}
/**
 * 优惠活动领取彩金
 *
 * @description 优惠活动领取彩金
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function confirmActivityPrize(playload) {
  return request({
    url: "/api/v2/cms/confirmActivityPrize",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 七牛图片（支持多文件）上传
 *
 * @description 图片（支持多文件）上传
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function qiniuUpload(playload, config) {
  return request({
    url: "/api/v2/cms/qiniuUpload",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 公告文章列表
 *
 * @description 公告文章列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAnnounceEssayList(playload) {
  return request({
    url: "/api/v2/cms/queryAnnounceEssayList",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 获取头像列表
 *
 * @description 获取头像列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function headImg(playload, config) {
  return request({
    url: "/api/v2/cms/headImg",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 获取国际版优惠活动分类列表
 *
 * @description 获取国际版优惠活动分类列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryDiscountInternational() {
  return request({
    url: "/api/v2/cms/discountInternational",
    method: "POST",
    noEncrypt: true
  });
}
/**
 * 获取线路接口
 * @param {Object} playload
 *
 */
// export async function queryThreadList(playload) {
//   return request({
//     url: "/app/getApiLine",
//     method: "POST",
//     data: playload,
//     noEncrypt: false
//   });
// }

export async function fetchAgentDesc(playload = { type: 7 }) {
  return request({
    url: "/api/v2/cms/agentDescription",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
